import React, { useEffect, useState } from "react";
import {
    Box, Typography, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, Button, TextField, 
    Stack, IconButton, Dialog, DialogTitle, DialogContent, 
    DialogActions, MenuItem, TablePagination, Chip, Switch, InputAdornment
} from "@mui/material";
import { Add, Edit, Delete, Search, Fastfood } from "@mui/icons-material";
import { collection, getDocs, doc, setDoc, deleteDoc, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";

function Canteenmenu() {
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Form States
    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        category: "Breakfast",
        price: 0,
        isAvailable: true,
        schoolId: "zIlbJM5BjyrlEhg7fWKs"
    });

    useEffect(() => { loadMenu(); }, []);

    const loadMenu = async () => {
        setLoading(true);
        try {
            const q = query(collection(db, "canteenmenu"), orderBy("name", "asc"));
            const snap = await getDocs(q);
            setMenuItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    const handleOpen = (item = null) => {
        if (item) {
            setEditId(item.id);
            setFormData({ ...item });
        } else {
            setEditId(null);
            setFormData({ name: "", category: "Breakfast", price: 0, isAvailable: true, schoolId: "zIlbJM5BjyrlEhg7fWKs" });
        }
        setOpen(true);
    };

    const handleSave = async () => {
        if (!formData.name) return alert("Enter item name");
        const docId = editId || doc(collection(db, "canteenmenu")).id;
        
        try {
            await setDoc(doc(db, "canteenmenu", docId), {
                ...formData,
                price: Number(formData.price),
                updatedAt: new Date().toISOString(),
                createdAt: formData.createdAt || new Date().toISOString()
            });
            setOpen(false);
            loadMenu();
        } catch (e) { console.error(e); }
    };

    const toggleAvailability = async (item) => {
        const docRef = doc(db, "canteenmenu", item.id);
        await setDoc(docRef, { isAvailable: !item.isAvailable }, { merge: true });
        loadMenu();
    };

    const handleDelete = async (id) => {
        if (window.confirm("Remove this item from menu?")) {
            await deleteDoc(doc(db, "canteenmenu", id));
            loadMenu();
        }
    };

    const filteredMenu = menuItems.filter(m => 
        m.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        m.category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Box p={2}>
            <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 3 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="bold">Canteen Menu Manager</Typography>
                    <Stack direction="row" spacing={1}>
                        <TextField 
                            placeholder="Search snacks..." 
                            size="small" 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> }}
                        />
                        <Button variant="contained" startIcon={<Add />} onClick={() => handleOpen()}>Add Item</Button>
                    </Stack>
                </Stack>
            </Paper>

            <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                <Table size="small">
                    <TableHead sx={{ bgcolor: '#fafafa' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', width: 50 }}>Sr.</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Item Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Category</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Price</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Available</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredMenu.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                            <TableRow key={item.id} hover>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                                <TableCell>
                                    <Chip label={item.category} size="small" variant="outlined" sx={{ fontSize: '10px', height: 20 }} />
                                </TableCell>
                                <TableCell>₹{item.price}</TableCell>
                                <TableCell align="center">
                                    <Switch 
                                        size="small" 
                                        checked={item.isAvailable} 
                                        onChange={() => toggleAvailability(item)}
                                        color="success"
                                    />
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton size="small" onClick={() => handleOpen(item)}><Edit fontSize="small" color="primary" /></IconButton>
                                    <IconButton size="small" onClick={() => handleDelete(item.id)}><Delete fontSize="small" color="error" /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredMenu.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                />
            </TableContainer>

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>{editId ? "Edit Item" : "New Menu Item"}</DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={2} py={1}>
                        <TextField label="Item Name (e.g. Pohe)" fullWidth size="small" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} />
                        <TextField select label="Category" fullWidth size="small" value={formData.category} onChange={e => setFormData({...formData, category: e.target.value})}>
                            {["Breakfast", "Lunch", "Snacks", "Beverages", "Dessert"].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                        </TextField>
                        <TextField label="Price (₹)" type="number" fullWidth size="small" value={formData.price} onChange={e => setFormData({...formData, price: e.target.value})} />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save Item</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default Canteenmenu;